module.exports = __webpack_public_path__ + "static/media/creative-tim-white-slim2.df0cdbfb.png";